const TASK_DUPLICATE_FILTER = {
  DUPLICATE: {
    label: 'Duplicate',
    value: 'DUPLICATE',
  },
  NOT_DUPLICATE: {
    label: 'Not Duplicate',
    value: 'NOT_DUPLICATE',
  },
}

export default TASK_DUPLICATE_FILTER
